import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FolderTrackingCustomization } from '../models/folder-tracking-customization';
import { CrudService } from './crud-service';
import { MemoryService } from './memory.service';

@Injectable({
    providedIn: 'root',
})
export class FolderTrackingCustomizationService extends CrudService {
    /**
     * Constructeur
     **/
    constructor(
        private http: HttpClient,
        public override memoryService: MemoryService
    ) {
        super(memoryService);
    }

    /**
     * Met à jour la personnalisation de suivi de dossier de la vue courante.
     * @param folderTrackingCustomization Instance de la personnalisation de suivi de dossier.
     * @returns La personnalisation de suivi de dossier mise à jour.
     */
    public update(folderTrackingCustomization: FolderTrackingCustomization): Observable<FolderTrackingCustomization> {
        // Appel de la Web Api
        return this.http
            .put<FolderTrackingCustomization>(this.baseUrl + `/api/organizations/${this.organizationId}/views/${this.viewId}/tracking-customization`, folderTrackingCustomization)
            .pipe(
                map((x) => {
                    return FolderTrackingCustomization.from(x);
                })
            );
    }

    /**
     * Récupère la personnalisation de suivi de dossier de la vue courante.
     * @returns La personnalisation de suivi de dossier de la vue courante.
     */
    get(): Observable<FolderTrackingCustomization> {
        // Appel de la Web Api
        return this.http
            .get<FolderTrackingCustomization>(this.baseUrl + `/api/organizations/${this.organizationId}/views/${this.viewId}/tracking-customization`, this.getDefaultHttpOptions())
            .pipe(
                map((x) => {
                    return FolderTrackingCustomization.from(x);
                })
            );
    }
}
